import { getErrorsFor, globalErrorCondition } from "../../../Helpers/ErrorHelper";
import {
    bookingConfirmed,
    bookingUpdated,
} from "../Redux/BookingGlobalActions";
import { objectToFormData } from '../../../Helpers/FormHelper';
import { BOOKINGS_API_URL } from "../Bookings";
import { bookingFormErrorsReturned } from "../Redux/BookingFormSlice";

export const submitBooking = (bookingConfig, category, amenity, data) => async (dispatch, getState) => {
    let requestParams = {
        amenity_id: data.amenity_id,
        user_id: data.user_id,
        unit_id: data.unit_id,
        start: data.start,
        end: data.end,
        notes: data.notes,
        terms_accepted: data.terms_accepted,
    };

    // We only want to send up the recurrence and rescheduled properties if
    // recurring bookings are enabled AND we are creating a new booking/series
    if (bookingConfig.recurring_bookings && !data.id) {
        requestParams.recurrence = data.recurrence;
        requestParams.rescheduled_occurrences = data.rescheduled_occurrences;
    }

    if (data.visitors_added) {
        requestParams.visitors_added = data.visitors_added;
        requestParams.visitors_notes = data.visitors_notes;
        requestParams.visitors = data.visitors;
    }

    if (data.form) {
        requestParams.form = data.form;
    }

    let formData = objectToFormData({ booking: requestParams });

    let url = `${BOOKINGS_API_URL}booking`

    // If editing a booking, we need to specify the booking slug in the url
    if (data.id) {
        url = `${BOOKINGS_API_URL}booking/${data.slug}`;
        formData.set('_method', 'put');
    }

    await axios({
        url: url,
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
        .then( response => {
            if (data.id) {
                dispatch(bookingUpdated(typeof (response.data.data.booking) !== 'undefined'));
            } else {
                dispatch(bookingConfirmed(response.data.data.booking));
            }
        })
        .catch( error => {
            if (error.response) {
                const bookingErrors = getErrorsFor(error.response.data.errors, 'booking.', true);
                dispatch( bookingFormErrorsReturned(bookingErrors) )
            } else {
                globalErrorCondition('Error in booking submission', error);
                return Promise.reject();
            }
        });
}
